import * as _ from 'lodash';

const PhoneNumber = require('awesome-phonenumber');

export function toStartCasing(str) {
  return _.startCase(_.toLower(str));
}

export const HELP_MSG_KEY = 'helpMessages';

export const convertPhoneNumberToInternationalPhoneNumber = (
  number,
  countryCode
) => {
  const phoneNumber = new PhoneNumber(number, countryCode);
  const convertedPhoneNumber = phoneNumber.getNumber();
  if (phoneNumber.isMobile()) {
    return convertedPhoneNumber;
  }
  // if conversion failed, return the raw input back
  return number;
};

export const RTCOutgoingCommand = {
  THREAD_JOIN: 'THREAD_JOIN',
  THREAD_LEAVE: 'THREAD_LEAVE',
  THREAD_MESSAGE: 'THREAD_MESSAGE',
  NOTIFICATION_SEEN: 'NOTIFICATION_SEEN'
};

export const RTCIncomingMessageTypes = {
  ERROR: 'ERROR',
  THREAD_JOIN_SUCCESS: 'THREAD_JOIN_SUCCESS',
  THREAD_LEAVE_SUCCESS: 'THREAD_LEAVE_SUCCESS',
  THREAD_MESSAGE_SUCCESS: 'THREAD_MESSAGE_SUCCESS',
  THREAD_MESSAGE_RECEIVED: 'THREAD_MESSAGE_RECEIVED',
  NOTIFICATION: 'NOTIFICATION',
  NOTIFICATION_SEEN_SUCCESS: 'NOTIFICATION_SEEN_SUCCESS'
};

export const NotificationType = {
  SYSTEM: 'SYSTEM',
  NEW_MESSAGE: 'NEW_MESSAGE'
};

export const RTC = '@@RTC';

export const getEditDistance = (a, b) => {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  let dp = [];

  // increment along the first column of each row
  let i, j;
  for (i = 0; i <= b.length; i++) {
    dp[i] = [i];
  }

  // increment each column in the first row
  for (j = 0; j <= a.length; j++) {
    dp[0][j] = j;
  }

  // Fill in the rest of the dp
  for (i = 1; i <= b.length; i++) {
    for (j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] =
          Math.min(dp[i - 1][j - 1], Math.min(dp[i][j - 1], dp[i - 1][j])) + 1;
      }
    }
  }

  return dp[b.length][a.length];
};
